import { Observable } from "rxjs";
import { ComboColumnSettings } from "../combo-column/models";
import { MultiSelectColumnSettings } from "../multi-select-column/multi-select-models";

export type DataSourceFn = (dataItem: any) => any[] | Observable<any[]>;


/**
 * Specify the possible column types supported by the grid
 */
export enum ColumnType {
  text = 1,
  numeric = 2,
  boolean = 3,
  date = 4,
  time = 5,
  combo = 6,
  multi = 7,
  action = 8,
  icon = 9,
  link = 10

  //link = 'link';
  //file = 'file';
  //autocomplete = 'autocomplete';
  //icon = 'icon';
  //color = 'color';
}

export interface ColumnSettings {
  /** field that is binded to grid data */
  field: string;

  /** column title */
  title: string;

  /** column type */
  type: ColumnType;

  /** define if the column can be editable, false by default
   * property available for all the controls (column types) except the action column */
  isEditable?: boolean | string;

  // This property indicates whether the column can be sorted.
  // If isNotSortable is true, the column cannot be sorted.
  isNotSortable?: boolean;

  validation?: {
    isRequired?: boolean | string;
    min?: number | string;
    minDate?: Date | string;
    max?: number | string;
    maxDate?: Date | string;
    minLength?: number;
    maxLength?: number;
  };
  //defines if the column can be reordered or not, if this value is true the user can drag the column and change its position in the grid
  //as long as the scReorderColumns of the grid component is true
  isReorderable?: boolean;

  /**
   * Provide settings for columns of type 'combo'
   */
  comboSettings?: ComboColumnSettings;

  /**
   * Provide settings for columns of type 'multi'
   */
  multiSelectSettings?: MultiSelectColumnSettings;

  cssClass?: string;

  /**
   * Show text on icon mouse hovering
   */
  hover?: string;

  actionSettings?: {
    name: string;
    /** Callback function to be executed when the action is triggered */
    callback: (dataItem: any) => void;
    /** Function to determine if the action is disabled for a specific data item (row) */
    isDisabled?: (dataItem: any) => boolean;
  };

  hiddenByDefault?: boolean;

  /**
   * Real link column (supports open in new tab).
   */
  linkSettings?: {
    name: string;
    // routerLink can be a full URL string or an array of route segments
    routerLink: (dataItem: any) => string | (string | number)[];
  };
}
